import { LicenseState } from "./data-collection.types";
import { getStartInfo } from "./start-info";
export const defaultLicenseState = LicenseState.inactive;
export function isValidLicenseState(candidate) {
    return (typeof candidate === "string" &&
        Object.values(LicenseState).includes(candidate));
}
export async function doesLicenseStateMatch(behavior) {
    const { licensing, prefs } = getStartInfo();
    await prefs.untilLoaded;
    if (!behavior.licenseStateList) {
        return true;
    }
    const licenseStates = behavior.licenseStateList.split(",");
    const isActive = await licensing.isLicenseValid();
    for (const licenseState of licenseStates) {
        if (licenseState === LicenseState.inactive && !isActive) {
            return true;
        }
        if (licenseState === LicenseState.active && isActive) {
            return true;
        }
    }
    return false;
}
